module.exports = __webpack_public_path__ + "bed-button-explore.97705615.png";